<template>
  <v-card width="100%">
    <div class="barometer-wrapper">
      <div class="barometer-header">
        <h2>Afspraken</h2>
        <!-- Voorheen "Totale doelstelling" -->
        <h3 v-if="selectedDataView == 'months'">
          <span v-for="(month, index) in months" :key="index">
            <span v-if="month.id == selectedDataMonths">{{ month.name }}</span>
          </span>
        </h3>

        <h3
          v-if="selectedDataView == 'fourweeks'"
        >week {{(selectedDataFourWeeks * 4) - 3 }} t/m {{(selectedDataFourWeeks * 4)}}</h3>
        <h3 v-if="selectedDataView == 'weeks'">week {{ selectedDataWeek }}</h3>
      </div>

      <!-- Week view -->
      <div v-if="selectedDataView == 'weeks'">
        <GChart type="ColumnChart" :data="chartDataWeek" :options="chartOptions"/>
        <div style="text-align: center;"><strong>{{appointmentsThisYear.weeks[selectedDataWeek - 1].total}} </strong> afspraken week {{selectedDataWeek}} dit jaar</div>
        <div style="text-align: center;"><strong>{{appointmentsYearAgo.weeks[selectedDataWeek - 1].total}} </strong> afspraken week {{selectedDataWeek}} vorig jaar </div>
      </div>

      <!-- Month view -->

      <div v-if="selectedDataView == 'months'">
        <GChart type="ColumnChart" :data="chartDataMonth" :options="chartOptions"/>
        <div style="text-align: center;"><strong>{{appointmentsThisYear.months[selectedDataMonths - 1].total}} </strong> afspraken<span v-for="(month, index) in months" :key="index">
            <span v-if="month.id == selectedDataMonths"> {{ month.name }}</span>
          </span> dit jaar</div>
        <div style="text-align: center;"><strong>{{appointmentsYearAgo.months[selectedDataMonths - 1].total}} </strong> afspraken <span v-for="(month, index) in months" :key="index">
            <span v-if="month.id == selectedDataMonths"> {{ month.name }}</span>
          </span> vorig jaar </div>
      </div>

      <!-- fourweeks view -->

      <div v-if="selectedDataView == 'fourweeks'">
        <GChart type="ColumnChart" :data="chartDataFourWeeks" :options="chartOptions"/>
        <div style="text-align: center;"><strong>{{appointmentsThisYear.weeks[selectedDataFourWeeks - 1].total}} </strong> afspraken week {{(selectedDataFourWeeks * 4) - 3 }} t/m {{(selectedDataFourWeeks * 4)}} dit jaar</div>
        <div style="text-align: center;"><strong>{{appointmentsYearAgo.weeks[selectedDataFourWeeks - 1].total}} </strong> afspraken week {{(selectedDataFourWeeks * 4) - 3 }} t/m {{(selectedDataFourWeeks * 4)}} vorig jaar </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { bus } from "../../main";
import { Bar } from 'vue-chartjs'
export default {
  

  props: [
    "appointmentsThisYear",
    "appointmentsYearAgo",
    "weeknr",
    "selectedDataView",
    "selectedDataWeek",
    "selectedDataMonths",
    "selectedDataFourWeeks",
    "months",
    "colorSecondary",
    "colorPrimary"
  ],
  name: "visitors",
  data: () => ({
    mini: true,
    id: null, //passed getal door
    canvasRender: null,
    chartDataWeek: [["Afspraken", "Afspraken" , { role: 'style' }]],
    chartDataMonth: [["Afspraken", "Afspraken" , { role: 'style' }]],
    chartDataFourWeeks: [["Afspraken", "Afspraken" , { role: 'style' }]],
    chartOptions: {
      legend: { position: "none" },
      isStacked: false,

      vAxis: {
        minValue: 0,
        textColor: "#646464",
        format: "#",
        baselineColor: "#cccccc",
        gridlineColor: "#cccccc",
        textStyle: {
          fontSize: 0
        }
      },
      chartArea: {
        left: 40,
        right: 0,
        top: 20,
        bottom: 30
      },
      hAxis: {
        stroke: "white",
        format: "date",
        baselineColor: "#cccccc",
        gridlineColor: "#cccccc",
        textColor: "#646464",
        textStyle: {
          fontSize: 13
        }
      },
      backgroundColor: "#fff"
    },
  }),

  created() {
    bus.$on("salonBarometerUpdate", this.updateData);
  },

  mounted() {
    this.updateData();
  },

  methods: {
    updateData() {
     // console.log("Update data Visitors");

      // Push Weekdata naar Google Charts Data
      let periodeDataWeek = [
        'Dit jaar',
        this.appointmentsThisYear.weeks[this.selectedDataWeek - 1].total,
        this.colorPrimary
      ]
      this.chartDataWeek.push(periodeDataWeek)

      let periodeDataLastYearWeek = [
        'Vorig jaar',
        this.appointmentsYearAgo.weeks[this.selectedDataWeek - 1].total,
        this.colorSecondary
      ]
      this.chartDataWeek.push(periodeDataLastYearWeek)

      // Push Maanddata naar Google Charts Data
      let periodeDataMonth = [
        'Dit jaar',
        this.appointmentsThisYear.months[this.selectedDataMonths - 1].total,
        this.colorPrimary
      ]
      this.chartDataMonth.push(periodeDataMonth)

      // Push Jaardata naar Google Charts Data
      let periodeDataLastYearMonth = [
        'Vorig jaar',
        this.appointmentsYearAgo.months[this.selectedDataMonths - 1].total,
        this.colorSecondary
      ]
      this.chartDataMonth.push(periodeDataLastYearMonth)


      let periodeDataFourWeeks = [
        'Dit jaar',
        this.appointmentsThisYear.fourweeks[this.selectedDataFourWeeks - 1].total,
        this.colorPrimary
      ]
      this.chartDataFourWeeks.push(periodeDataFourWeeks)

      let periodeDataLastYearFourWeeks = [
        'Vorig jaar',
        this.appointmentsYearAgo.fourweeks[this.selectedDataFourWeeks - 1].total,
        this.colorSecondary
      ]
      this.chartDataFourWeeks.push(periodeDataLastYearFourWeeks)
    }
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    indicate() {}
  }
};
</script>
